export function scheduleSpaReadyAfterPaint() {
  if (typeof window === 'undefined') return () => {};

  let cleanupIdleId: number | null = null;
  let loaderRemovalTimeoutId: number | null = null;
  let prerenderCleanupTimeoutId: number | null = null;
  let firstFrameId: number | null = null;
  let secondFrameId: number | null = null;

  const removeById = (id: string) => {
    try {
      document.getElementById(id)?.remove();
    } catch {}
  };

  const markVisualReady = () => {
    try {
      document.documentElement.classList.add('spa-ready');
    } catch {}

    loaderRemovalTimeoutId = window.setTimeout(() => {
      removeById('human-loader');
    }, 240);
  };

  const cleanupPrerenderShell = () => {
    removeById('prerender-shell');
  };

  firstFrameId = window.requestAnimationFrame(() => {
    secondFrameId = window.requestAnimationFrame(markVisualReady);
  });

  if (typeof window.requestIdleCallback === 'function') {
    cleanupIdleId = window.requestIdleCallback(cleanupPrerenderShell, {
      timeout: 3500,
    });
  } else {
    prerenderCleanupTimeoutId = window.setTimeout(cleanupPrerenderShell, 3500);
  }

  return () => {
    if (
      cleanupIdleId != null &&
      typeof window.cancelIdleCallback === 'function'
    ) {
      window.cancelIdleCallback(cleanupIdleId);
    }

    if (loaderRemovalTimeoutId != null) {
      window.clearTimeout(loaderRemovalTimeoutId);
    }

    if (prerenderCleanupTimeoutId != null) {
      window.clearTimeout(prerenderCleanupTimeoutId);
    }

    if (firstFrameId != null) {
      window.cancelAnimationFrame(firstFrameId);
    }

    if (secondFrameId != null) {
      window.cancelAnimationFrame(secondFrameId);
    }
  };
}
